export default __webpack_public_path__ + "static/media/n13.529e962a.jpg";